import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"
import { isDark, brl } from "../../lib/utils"

// Connects to data-controller="graphs--cost-centers"
export default class extends Controller {
  static values = {
    data: Object
  }

  connect() {
    this.labels = this.dataValue.categories || []
    this.series = this.dataValue.series || []

    // Don't render chart if there's no data
    if (this.labels.length === 0) {
      this.element.innerHTML = `
        <div class="flex items-center justify-center h-full text-base-content/60 text-sm">
          Sem dados para exibir
        </div>
      `
      return
    }

    this.chart = new ApexCharts(this.element, {
      chart: {
        type: 'bar',
        stacked: false,
        height: '100%',
        width: '100%',
        toolbar: { show: false },
        fontFamily: 'inherit',
        parentHeightOffset: 0,
      },
      states: {
        hover: {
          filter: { type: 'none' }
        },
        active: {
          filter: { type: 'none' }
        }
      },
      series: this.series,
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: `${100 / (this.series.length || 1)}%`,
          borderRadius: 2,
          borderRadiusApplication: 'end',          
        }
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        fontSize: '12px',
        markers: { size: 8 },
        labels: {
          colors: 'var(--color-base-content)',
        },        
      },
      xaxis: {
        categories: this.labels,
        labels: { show: false },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: {
        labels: {
          show: true,
          maxWidth: 220,
          style: {
            fontSize: '12px',
            colors: 'var(--color-base-content)',
          }
        },
      },
      colors: ['var(--color-success)', 'var(--color-error)'],
      fill: {
        opacity: 0.95,
      },
      grid: {
        show: false,
      },
      dataLabels: { enabled: false },
      tooltip: {
        shared: true,
        intersect: false,
        custom: ({ dataPointIndex }) => {
          const fullLabel = this.labels[dataPointIndex]
          const rows = this.series.map((item, index) => {
            const value = brl.format((item.data[dataPointIndex] || 0) / 100)
            const color = ['var(--color-success)', 'var(--color-error)'][index]

            return `<div class="flex items-center justify-between gap-2 px-4">
              <span>${item.name}</span>
              <span class="font-medium" style="color:${color}">${value}</span>
            </div>`
          }).join('')

          return `<div class="py-2 text-xs bg-base-100 border text-base-content rounded-box shadow-2xl">
            <div class="font-semibold mb-2 border-b px-4 pb-2">${fullLabel}</div>
            <div class="space-y-2">
              ${rows}
            </div>
          </div>`
        }
      },
      responsive: [{
        breakpoint: 768,
        options: {
          yaxis: {
            labels: { maxWidth: 60 }
          }
        }
      }]
    })

    this.chart.render()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
